import * as React from 'react';

import getDeviceInformation from '../../utils/get-device-util/get-device-util';
import { ContextProps } from './types';

export const APP_CONTEXT: ContextProps = {
  device: getDeviceInformation()
};

export const Context = React.createContext<ContextProps>(APP_CONTEXT);
